import normalizeLanguages from './normalizeLanguages.js';

/**
 * сбор различных данных о среде выполнения JavaScript в браузере.
 * @param {Window} window
 * @returns {Promise<ICollectData>}
 */
async function collectData(window) {
    const navigator = window.navigator;
    const language = navigator.language ? navigator.language.split('-')[0].toLowerCase() : null;
    const languages = normalizeLanguages(navigator.languages);
    const plugins = navigator.plugins ? [...navigator.plugins].map(p => p.name) : null;

    /** @type INavigatorData */
    const navigatorData = {
        deviceMemory: navigator.deviceMemory ?? null,
        hardwareCount: navigator.hardwareConcurrency ?? null,
        language,
        languages,
        productSub: navigator.productSub ?? null,
        doNotTrack: navigator.doNotTrack ?? null,
        platform: navigator.platform ?? null,
        buildID: navigator.buildID ?? null,
        vendor: navigator.vendor ?? null,
        plugins,
    };

    /** @type IWindowData */
    const windowData = {
        screenWidth: window.screen.width ?? null,
        screenHeight: window.screen.height ?? null,
        colorDepth: window.screen.colorDepth ?? null,
        availTop: window.screen.availTop ?? null,
        availLeft: window.screen.availLeft ?? null,
        availHeight: window.screen.availHeight ?? null,
        availWidth: window.screen.availWidth ?? null,
        historyLength: window.history.length ?? null,
    };

    return {
        ...navigatorData,
        ...windowData,
        // eslint-disable-next-line new-cap
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // move ??
    };
}

export default collectData;